import { notNullNorUndefined } from "./notNullNorUndefined";

const params = new URLSearchParams(document.location.search);

//
// Overloads for `parseUrlParams` function
//

/**
 * Return a parsed or `fallbackValue` when a test is provided
 */
function parseUrlParams<T>(
  targetParam: Parameters<typeof params.get>[0],
  fallbackValue: T,
  testAndTargetValue: T
): T;

/**
 * Return the found or `fallbackValue` when no test is provided
 */
function parseUrlParams<T>(
  targetParam: Parameters<typeof params.get>[0],
  fallbackValue: T
): T | string;

function parseUrlParams<T extends string | number | boolean | null>(
  targetParam: Parameters<typeof params.get>[0],
  fallbackValue: T,
  testAndTargetValue?: T
): T | string {
  const paramValue = params.get(targetParam);
  if (notNullNorUndefined(paramValue)) {
    if (testAndTargetValue !== undefined) {
      const test = testAndTargetValue === null ? "null" : testAndTargetValue;
      if (paramValue.toLowerCase() === test.toString()) {
        return testAndTargetValue;
      }
    } else {
      return paramValue;
    }
  }
  return fallbackValue;
}

export { parseUrlParams };
